module.exports = __webpack_public_path__ + "static/img/banner-to.0132218.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-to.jpg
// module id = ZnSd
// module chunks = 1